var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"className":"align-center justify-center"}},[_c('v-col',{attrs:{"cols":"12","md":"12","align-self":"center"}},[_c('div',{attrs:{"id":"chart-percentage-evolution"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }